module.exports = __webpack_public_path__ + "static/media/wizualizacja-118.31872c77.png";